import { ChatIcon, ChatUnreadIcon } from "@100mslive/react-icons";
import { FEATURE_LIST, SIDE_PANE_OPTIONS } from "../../common/constants";
import {
  selectUnreadHMSMessagesCount,
  useHMSStore,
} from "@100mslive/react-sdk";
import {
  useIsSidepaneTypeOpen,
  useSidepaneToggle,
} from "../AppData/useSidepane";

import IconButton from "../../IconButton";
import { Tooltip } from "@100mslive/react-ui";
import { useIsFeatureEnabled } from "../hooks/useFeatures";
import { useTranslation } from "react-i18next";

export const ChatToggle = () => {
  const { t } = useTranslation();

  const countUnreadMessages = useHMSStore(selectUnreadHMSMessagesCount);
  const isChatOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.CHAT);
  const toggleChat = useSidepaneToggle(SIDE_PANE_OPTIONS.CHAT);
  const isFeatureEnabled = useIsFeatureEnabled(FEATURE_LIST.CHAT);

  if (!isFeatureEnabled) {
    return;
  }

  return (
    <Tooltip
      key="chat"
      title={t("fm_open_chat", {
        action: t(isChatOpen ? "lbl_close" : "lbl_open"),
      })}
    >
      <IconButton
        onClick={toggleChat}
        active={!isChatOpen}
        data-testid="chat_btn"
      >
        {countUnreadMessages === 0 ? (
          <ChatIcon />
        ) : (
          <ChatUnreadIcon data-testid="chat_unread_btn" />
        )}
      </IconButton>
    </Tooltip>
  );
};
